import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";

import Color from "color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createUseStyles } from "react-jss";
import { getPersonStyle } from "./PersonCardResult";
import { mergeDeepRight } from "ramda";

const useStyles = createUseStyles((theme) =>
  mergeDeepRight(getPersonStyle(theme), {
    avatarImg: {
      marginBottom: "15px",
      width: "35px",
      height: "35px",
      border: `1px solid ${theme.separatorGraySecondary}`,
      borderRadius: "70%",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top",
      cursor: "pointer",
    },
    badgesRow: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      marginBottom: "0px",
      marginTop: "4px",
    },
    headerBadgeWrapper: {
      height: "21px",
      maxWidth: "100%",
      margin: "0 5px 2px 0",
      padding: "0 5px 0 5px",
      border: "0",
      borderRadius: "2px",
      color: theme.secondaryColor,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: Color(theme.secondaryColor).alpha(0.1).string(),
    },
    headerBadgeText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "13px",
      lineHeight: "16px",
    },
    contactInfoText: {
      composes: "$multilineEllipsis",
    },
    title: {
      composes: ["$multilineEllipsis", theme.cardWidth],
      color: theme.cardTextColor,
      height: "16px",
      fontStyle: "normal",
      fontWeight: "200",
      fontSize: "12px",
      lineHeight: "110%",
      marginBottom: "8px",
      cursor: "pointer",
    },
  })
);

export default ({ result, suggestionClick, onMapClick }) => {
  const phoneSuggestions = result.suggestions.filter((x) => x.phone);

  const mainAddress =
    result.address || result.edges.map((e) => e.address).find((x) => x);
  const mainAddressTitle = result.edges
    .filter((e) => e.address === mainAddress)
    .map((e) => e.title)
    .find((x) => x);

  const styles = useStyles();

  return (
    <div>
      <div>
        {result.avatarUrl || result.imageUrl ? (
          <div
            className={styles.avatarImg}
            style={{
              backgroundImage: `url("${result.avatarUrl || result.imageUrl}")`,
            }}
          />
        ) : null}
        <div className={styles.header}>{result.title}</div>
        <div className={styles.title}>{result.text}</div>
        {phoneSuggestions.map((phoneSuggestion, i) => (
          <div key={i}>
            <div
              className={styles.contactInfoWrapper}
              onClick={suggestionClick(phoneSuggestion)}
            >
              <div className={styles.contactInfoRow}>
                <FontAwesomeIcon
                  className={[styles.contactInfoIcon, styles.flipped].join(" ")}
                  aria-hidden="true"
                  icon={faPhone}
                />
                <div key={i} className={styles.contactInfoText}>
                  {phoneSuggestion.phone}
                </div>
              </div>
            </div>
            <div className={styles.contactInfoSeparator} />
          </div>
        ))}
        {mainAddress ? (
          <div>
            <div
              className={styles.contactInfoWrapper}
              onClick={(e) => {
                e.stopPropagation(); // The entire card is clickable.
                onMapClick([result]);
              }}
            >
              <div className={styles.addressWrapper}>
                <FontAwesomeIcon
                  className={styles.contactInfoIcon}
                  aria-hidden="true"
                  icon={faMapMarkerAlt}
                />
                <div className={styles.addressLinesWrapper}>
                  {mainAddressTitle && (
                    <div className={styles.addressInfoRow}>
                      <div className={styles.contactInfoText}>
                        {mainAddressTitle}
                      </div>
                    </div>
                  )}
                  <div className={styles.addressInfoRow}>
                    <div className={styles.contactInfoText}>{mainAddress}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.contactInfoSeparator} />
          </div>
        ) : null}
      </div>
      <div>
        {result.headers && (
          <div className={styles.badgesRow}>
            {result.headers.map((badgeText, i) => (
              <div className={styles.headerBadgeWrapper} key={i}>
                <div className={styles.headerBadgeText}>{badgeText}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
